export default "__VITE_ASSET__CxouUjwV__"